export const COUNTDOWN_LABEL_AUCTION_CLOSED = 'Auction closed';
